// fontawesome.js (create this file anywhere, e.g., src/icons/fontawesome.js)
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCommentDots } from '@fortawesome/free-solid-svg-icons';

library.add(faCommentDots);
